import {useQuery} from 'react-query';
import {CatalogItemVO, ServicesApi} from '../api';
import {useMapioContext} from '../mapioContext';

export const CACHE_KEY_CATALOG_LAYERS = 'CACHE_KEY_CATALOG_LAYERS';

export const useCatalogLayers = (topic: string) => {
    const mapioContext = useMapioContext();
    const {context, lang} = mapioContext.value;
    return useQuery<CatalogItemVO[]>(
        [CACHE_KEY_CATALOG_LAYERS, topic],
        async () => (await ServicesApi.getCatalogLayers(topic, lang ?? 'cs', context)).data.results.root.children,
        {
            enabled: Boolean(topic),
            // Katalog vrstev je v rámci session statický – refetch na focus okna nechceme (reset viditelnosti vrstev).
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
        },
    );
};
